import {MaintenanceHistory} from "../../entities/MaintenanceHistory";

export class EditMaintenanceCtrl {
    $scope:any;
    entity:MaintenanceHistory;
    modalInstance:angular.ui.bootstrap.IModalServiceInstance;
    public static $inject = ['$scope','$uibModalInstance','maintenance'];
    constructor($scope:any, $modalInstance:angular.ui.bootstrap.IModalServiceInstance, maintenance:MaintenanceHistory) {
        this.$scope = $scope;
        this.entity = maintenance;
        this.modalInstance = $modalInstance;
        $scope.vm = this;
    }
    ok() {
        this.modalInstance.close(true);
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}
